export { default as AdYouTube } from "./AdYouTube";


// WEBPACK FOOTER //
// ./src/components/AdCard/AdYouTube/index.ts